module.exports = __webpack_public_path__ + "img/za.14e70522.svg";